export default __webpack_public_path__ + "static/media/favicon.266671b4.ico";